/**
 * First-level political divisions by country ISO-alpha2 code.
 * Used to populate the Region dropdown in project forms.
 */
export const REGIONS_BY_COUNTRY = {
  // Saudi Arabia — 13 Regions
  SA: [
    'Riyadh', 'Makkah', 'Madinah', 'Eastern Province', 'Asir',
    'Tabuk', 'Qassim', 'Hail', 'Jazan', 'Najran',
    'Al Bahah', 'Al Jawf', 'Northern Borders',
  ],

  // United Arab Emirates — 7 Emirates
  AE: [
    'Abu Dhabi', 'Dubai', 'Sharjah', 'Ajman',
    'Umm Al Quwain', 'Ras Al Khaimah', 'Fujairah',
  ],

  // Qatar — 8 Municipalities
  QA: [
    'Doha', 'Al Rayyan', 'Al Wakrah', 'Al Khor', 'Al Daayen',
    'Umm Salal', 'Al Shamal', 'Al Shahaniya',
  ],

  // Kuwait — 6 Governorates
  KW: [
    'Al Asimah (Capital)', 'Hawalli', 'Al Farwaniyah', 'Al Ahmadi',
    'Al Jahra', 'Mubarak Al Kabeer',
  ],

  // Bahrain — 4 Governorates
  BH: [
    'Capital', 'Muharraq', 'Northern', 'Southern',
  ],

  // Oman — 11 Governorates
  OM: [
    'Muscat', 'Dhofar', 'Musandam', 'Al Buraymi', 'Al Batinah North',
    'Al Batinah South', 'Ad Dakhiliyah', 'Ash Sharqiyah North',
    'Ash Sharqiyah South', 'Ad Dhahirah', 'Al Wusta',
  ],

  // Egypt — 27 Governorates
  EG: [
    'Cairo', 'Giza', 'Alexandria', 'Luxor', 'Aswan', 'Asyut',
    'Beni Suef', 'Dakahlia', 'Damietta', 'Fayyum', 'Gharbia',
    'Ismailia', 'Kafr El Sheikh', 'Matruh', 'Minya', 'Monufia',
    'New Valley', 'North Sinai', 'Port Said', 'Qalyubia', 'Qena',
    'Red Sea', 'Sharqia', 'Sohag', 'South Sinai', 'Suez',
    'Beheira',
  ],

  // Jordan — 12 Governorates
  JO: [
    'Amman', 'Irbid', 'Zarqa', 'Aqaba', 'Mafraq', 'Jerash',
    'Ajloun', 'Balqa', 'Karak', "Ma'an", 'Madaba', 'Tafilah',
  ],

  // Iraq — 18 Governorates
  IQ: [
    'Baghdad', 'Basra', 'Ninewa', 'Erbil', 'Sulaymaniyah', 'Kirkuk',
    'Diyala', 'Anbar', 'Babil', 'Wasit', 'Dhi Qar', 'Najaf',
    'Karbala', 'Muthanna', 'Maysan', 'Qadisiyyah', 'Saladin', 'Dohuk',
  ],

  // Lebanon — 8 Governorates
  LB: [
    'Beirut', 'Mount Lebanon', 'North Lebanon', 'South Lebanon',
    'Nabatieh', 'Bekaa', 'Akkar', 'Baalbek-Hermel',
  ],

  // Yemen — 22 Governorates
  YE: [
    "Sana'a", 'Aden', "Hadramawt", 'Taiz', "Al Hudaydah", "Ibb",
    'Al Bayda', 'Al Dali', 'Al Jawf', 'Al Mahrah', 'Al Mahwit',
    'Amran', 'Dhamar', 'Hajjah', 'Lahij', "Ma'rib", 'Raymah',
    "Sa'dah", "Shabwah", "Socotra", "Abyan", "Amanat Al Asimah",
  ],

  // Morocco — 12 Regions
  MA: [
    'Casablanca-Settat', 'Rabat-Salé-Kénitra', 'Marrakech-Safi',
    'Fès-Meknès', 'Tanger-Tétouan-Al Hoceïma', 'Souss-Massa',
    'Béni Mellal-Khénifra', 'Oriental', 'Drâa-Tafilalet',
    'Laâyoune-Sakia El Hamra', 'Dakhla-Oued Ed Dahab',
    'Guelmim-Oued Noun',
  ],

  // Turkey — 7 Geographical Regions
  TR: [
    'Marmara', 'Aegean', 'Mediterranean', 'Central Anatolia',
    'Black Sea', 'Eastern Anatolia', 'Southeastern Anatolia',
  ],

  // Pakistan — 4 Provinces + Territories
  PK: [
    'Punjab', 'Sindh', 'Khyber Pakhtunkhwa', 'Balochistan',
    'Islamabad Capital Territory', 'Gilgit-Baltistan', 'Azad Kashmir',
  ],

  // India — Major States
  IN: [
    'Maharashtra', 'Delhi', 'Karnataka', 'Tamil Nadu', 'Gujarat',
    'Rajasthan', 'Uttar Pradesh', 'West Bengal', 'Andhra Pradesh',
    'Telangana', 'Kerala', 'Punjab', 'Haryana', 'Madhya Pradesh',
    'Bihar', 'Odisha', 'Assam', 'Jharkhand', 'Uttarakhand',
    'Himachal Pradesh', 'Goa',
  ],
};

/**
 * Returns the list of regions for a given country code.
 * Returns null if the country has no defined regions.
 */
export const getRegionsForCountry = (countryCode) => {
  if (!countryCode) return null;
  return REGIONS_BY_COUNTRY[countryCode.toUpperCase()] || null;
};
